<template>
    <div>
        <label class="is-size-4 mb-1">{{ label }}</label>
        
        <v-select
            v-model="fieldValue"
            v-bind="$attrs"
            :items="items"
            persistent-hint
            return-object
            :single-line="!fieldLabel"
            :solo="!fieldLabel"
            :label="fieldLabel"
            flat
            :hide-details="$isMobile ? 'auto' : false"

            :rules="rules"
            validate-on-blur
            class="select-field"
            :placeholder="placeholder"

            :style="{'height': fieldHeight}"
            :height="fieldHeight"
            >
            <template #append>
                <v-icon class="mt-1" color="primary">mdi-chevron-down</v-icon>
            </template>
        </v-select>
    </div>
</template>

<script>
export default {
    props: {
        value: [Number, String, Object],
        fieldHeight: String,
        label: String,
        append: String,
        list: Array,
	    fieldLabel: String,
	    rules: Array,
        placeholder: String,
    },
    computed: {
        fieldValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        items() {
            return this.list;
        },
        appendText() {
            return this.append;
        },
    },
};
</script>

<style scoped>
/* .v-text-field__details { display: none; } */
</style>
